import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';
import {HelpService} from '../../../core/services/help.service';
import {HttpErrorResponse} from '@angular/common/http';
import {DialogBoxButtonColor, DialogBoxOption} from '../../../shared/models/dialog-box';
import {SpinnerComponent} from '../spinner/spinner.component';

@Component({
  selector: 'motn-help-bubble',
  templateUrl: './help-bubble.component.html',
  styleUrls: ['./help-bubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
  ],
})
export class HelpBubbleComponent implements OnInit {

  loadingUrl: boolean = false;


  constructor(
    private helpService: HelpService,
    private shadeTools: ShadeToolsService,
  ) {
  }


  ngOnInit(): void {
  }


  helpPopup(): void {
    this.loadingUrl = true;

    this.helpService.createHelpCenterToken$().subscribe(
      (st) => {
        this.loadingUrl = false;

        const options: DialogBoxOption[] = [
          {
            text: 'Access Knowledgebase',
            callback: () => {
            },
            href: {
              url: 'https://kb.motion.cloud',
              target: '_blank',
            },
            color: DialogBoxButtonColor.Green,
          },
          {
            text: 'Go Back',
            callback: () => {
            },
            color: DialogBoxButtonColor.Alt,
          },
        ];

        if (st.TicketSupportEnabled) {
          options.splice(1, 0, {
            text: 'Talk To Us',
            callback: () => {
              this.helpService.showSupportTicketWidget$(st);
            },
            color: DialogBoxButtonColor.Blue,
          });
        }

        this.shadeTools.startDialog(
          `<i class="fa-light fa-seal-question"></i> Help Center`,
          `What would you like to do?`,
          options,
        );
      },
      (err: HttpErrorResponse) => {
        this.loadingUrl = false;

        this.shadeTools.errorDialog(
          'Something went wrong while trying to connect you to the Help Center.\n\nPlease try again or visit help.motion.cloud on a different device.',
        );
      },
    );
  }
}
